import React, {Fragment} from 'react';
import CategoryList from "./CategoryList";
import {Autocomplete} from "@react-google-maps/api";
import Slider from "react-rangeslider";
import {SCHEMA_MAP, SCHEMA_LIST} from "../Const";

const initialState = {
    isOpen: false,
    autocomplete: '',
    filter: {
        locationIsSet: false,
        placeholder: 'Bitte Standort eingeben.',
        lat: null,
        lng: null,
        radius: 50,
        sort: null,
        categories: []
    }
}

class FilterMobile extends React.Component {

    static defaultProps = {
        filter: {
            radius: 50,
            categories: []
        },
        open: true,
        categories: [],
        members: [],
        schema: SCHEMA_MAP,
        onSelectCategory: (event) => {
        },
        onSelectPlace: (place) => {
        },
        onChangeSort: (value) => {}
    }

    constructor(props) {
        super(props);
        this.state = initialState;
        this.state.filter = {
            ...initialState.filter,
            ...this.props.filter
        }
    }


    componentDidMount() {
        this.setState({
            isOpen: this.props.open
        });

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.filter !== this.props.filter) {
            const locationIsSet = this.props.filter.lat !== null && this.props.filter.lng !== null;
            const wasLocationSet = prevProps.filter.lat !== null && prevProps.filter.lng !== null;

            this.setState({
                // Autocomplete-Text leeren wenn Standort-Filter entfernt wurde
                autocomplete: (wasLocationSet && !locationIsSet) ? '' : this.state.autocomplete,
                filter: {
                    ...this.state.filter,
                    radius: this.props.filter.radius,
                    locationIsSet: locationIsSet
                }
            });
        }
    }

    onLoadAutocomplete = (autocomplete) => {
        this.autocomplete = autocomplete
    }

    handleSchemaChange = (event, schema) => {
        event.preventDefault();
        this.props.onSchemaChange(schema);
    }

    handleToggleFilterFrom = (event) => {
        event.preventDefault();
        this.setState({
            isOpen: !(this.state.isOpen)
        })
    }

    handleSliderChange = (dist) => {
        this.props.onSliderChange(dist);
    }

    handleSliderChangeComplete = () => {
        this.props.onSliderChangeComplete();
    }

    handleSelectPlace = (filter, place) => {
        this.setState({
            autocomplete: place.formatted_address,
            filter: {
                ...this.state.filter,
                locationIsSet: true
            }
        });
        this.props.onSelectPlace(filter);
    }

    removeAutocomplete = (event) => {
        event.preventDefault();
        this.setState({
            autocomplete: '',
            filter: {
                ...this.state.filter,
                locationIsSet: false,
                lat: null,
                lng: null,
                placeholder: initialState.filter.placeholder
            }
        });

        this.props.removeGeoPosition(event);
    }

    handleGeoPosition = (event) => {
        event.preventDefault();
        this.setState({
            filter: {
                ...this.state.filter,
                locationIsSet: true,
                placeholder: 'Standort'
            }
        });

        this.props.handleGeoPosition(event);
    }

    render() {

        const {
            categories,
            members,
            onSelectCategory,
            schema,
            onChangeSort,
            filter
        } = this.props;

        return (
            <Fragment>
                <div className="filter">
                    <div className="container-fluid filter-buttons">
                        <div className="row">
                            <div className="col-xs-6">
                                <button onClick={this.handleToggleFilterFrom}>
                                    <i className="fas fa-search" /> Suchfilter
                                </button>
                            </div>
                            <div className="col-xs-6">
                                <button onClick={(event) => this.handleSchemaChange(event, SCHEMA_MAP)}>
                                    <i className="fa fa-map" /> Karte
                                </button>
                            </div>
                        </div>
                    </div>


                    <div className={'filter-form ' + (this.state.isOpen === true ? 'open' : 'close')}>
                        <div className="infobox-1">
                            <h2>Wonach suchen Sie?</h2>
                            <p>Filtern Sie anhand Ihres Standorts oder wählen Sie einen Fachbereich.</p>
                        </div>

                        <div className="infobox-button">
                            <a href="/arzt-und-kliniksuche/" className="btn-link w-100">
                                <i className="fa fa-question-circle"/> Informationen zu den Fachbereichen
                            </a>
                        </div>

                        <div className="infobox-2">
                            <h2>
                                <i className="fas fa-user-md"></i>
                                Wählen Sie einen Fachbereich?
                            </h2>

                            <CategoryList
                                filter={filter}
                                categories={categories}
                                onClick={onSelectCategory}
                                className={'mb-20'}
                            />

                        </div>


                        <div className="infobox-3">
                            <h2>
                                <i className="fas fa-location-arrow"></i>
                                Suchen Sie anhand Ihres Standorts
                            </h2>
                        </div>

                        <div className="autocomplete-wrapper mb-30">
                            <Autocomplete
                                onLoad={this.onLoadAutocomplete}
                                types={'(cities)'}
                                restrictions={{
                                    country: 'de'
                                }}
                                onPlaceChanged={(place) => {
                                    this.setState({
                                        filter: {
                                            ...this.state.filter,
                                            lat: this.autocomplete.getPlace().geometry.location.lat(),
                                            lng: this.autocomplete.getPlace().geometry.location.lng(),
                                        }
                                    }, () => {
                                        this.handleSelectPlace(this.state.filter, this.autocomplete.getPlace())
                                    })
                                }}
                            >
                                <input
                                    type={'text'}
                                    value={this.state.autocomplete}
                                    placeholder={this.state.filter.placeholder}
                                    onChange={(event) => {
                                        this.setState({
                                            autocomplete: event.target.value
                                        })
                                    }}
                                />
                            </Autocomplete>
                            {
                                (this.state.filter.locationIsSet === true)
                                    ?
                                    <a href="#!" onClick={this.removeAutocomplete} className="autocomplete-icon"><i className="fa fa-trash"/></a>
                                    :
                                    <a href="#!" onClick={this.handleGeoPosition} className="autocomplete-icon"><i className="fa fa-crosshairs"/></a>
                            }

                            {
                                (this.state.filter.locationIsSet === true)
                                    ?
                                    <div className='slider-horizontal mb-30'>
                                        <Slider
                                            min={0}
                                            max={400}
                                            step={5}
                                            value={this.props.filter.radius}
                                            onChange={this.handleSliderChange}
                                            onChangeComplete={this.handleSliderChangeComplete}
                                        />
                                        <div className='value'>Umkreis: {this.props.filter.radius} km</div>
                                    </div>
                                    :
                                    <div className="mb-30"/>
                            }

                            <div className="mb-30">
                                {
                                    (schema === SCHEMA_MAP)
                                        ? <button onClick={(event) => this.handleSchemaChange(event, SCHEMA_LIST)}>Zur
                                            Listenansicht</button>
                                        : <button onClick={(event) => this.handleSchemaChange(event, SCHEMA_MAP)}>Zur
                                            Kartenansicht</button>
                                }
                            </div>

                        </div>
                    </div>

                    <div className="container-fluid">
                        <div className="row mb-20 filter-bar">
                            <div className="col-xs-6">
                                <i className="fas fa-arrow-circle-down"/>
                                <select
                                    onChange={(e) => {
                                        onChangeSort(e.target.value);
                                   }}
                                    className={'filter-sort'}
                                >
                                    <option value={'date'}>Eintrittsdatum</option>
                                    <option value={'distance'}>Entfernung</option>
                                </select>
                            </div>
                            <div className="col-xs-6 text-right">
                                {members.length} Mitglieder
                            </div>
                        </div>
                    </div>

                </div>
            </Fragment>
        )
    }
}

export default FilterMobile;

